// extracted by css-extract-rspack-plugin
export default {"cls1":"useAttachment-cls1_MW0","cls2":"useAttachment-cls2_kHF useAttachment-cls1_MW0"};